export default function TrustSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-2/5 relative">
              <div className="w-full aspect-[3/4] lg:aspect-auto lg:h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20minimalist%20still%20life%20with%20premium%20leather%20bag%20and%20gold%20watch%20on%20dark%20slate%20surface%20with%20single%20orchid%20bloom%2C%20dramatic%20side%20lighting%2C%20high-end%20editorial%20quality%2C%20rich%20textures%2C%20moody%20elegant%20atmosphere%2C%20refined%20composition&width=700&height=900&seq=v2-trust-img&orientation=portrait"
                  alt="Trusted mulebuy spreadsheet resource"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="w-full lg:w-3/5 p-8 md:p-12 lg:p-16 flex flex-col justify-center">
              <span className="font-heading text-7xl md:text-8xl text-accent-300 leading-none mb-4">
                &ldquo;
              </span>
              <blockquote className="text-background-50 text-lg md:text-xl lg:text-2xl leading-relaxed mb-8 font-heading italic">
                The most organized <strong>mulebuy spreadsheet</strong> database I have ever found. It completely transformed how I source products &mdash; everything is categorized, updated daily, and incredibly easy to navigate.
              </blockquote>
              <div className="flex items-center gap-4 mb-8">
                <div>
                  <p className="text-background-50 font-semibold text-sm">Alex Morgan</p>
                  <p className="text-foreground-400 text-xs">E-commerce Product Sourcer</p>
                </div>
              </div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-300 text-foreground-950 text-sm font-semibold hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer w-fit"
              >
                Join Community
                <i className="ri-arrow-right-line"></i>
              </a>

              <div className="mt-10 pt-8 border-t border-foreground-800">
                <h4 className="text-background-50 text-sm font-semibold mb-3">Important Notice</h4>
                <div className="flex flex-col gap-2 text-foreground-400 text-xs leading-relaxed">
                  <p>This is an informational website only. We do not sell any products directly.</p>
                  <p>External links are provided for reference and we do not control their content.</p>
                  <p>All product data and listings are hosted on kaspreadsheet.com.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}